import React from 'react'
import Spinner from './Spinner'

const SpinnerLoader = ({ isLoading, children }) => {
  return isLoading ? <Spinner /> : children
}

export default SpinnerLoader
